import React, { useState } from 'react';
import { Button as MuiButton, styled } from '@material-ui/core';

import { sleep } from 'utils';

type Props = {
  testAction?: (() => Promise<string>) | null;
  text: string;
  disabled?: boolean;
  children?: never;
};

const Button = styled(MuiButton)({
  '&:disabled': {
    color: 'rgba(0, 0, 0, 0.87); !important',
    backgroundColor: '#b3cc45',
    filter: 'grayscale(0.15) brightness(0.85) !important',
  },
  border: '1px solid #000',
});

const TestButton: React.FC<Props> = ({
  testAction = null,
  text,
  disabled = false,
}) => {
  const [testMessage, updateMessage] = useState('');
  const [displayMessage, toggleMessage] = useState(false);
  const handleClick = async () => {
    if (testAction !== null) {
      const outcome = await testAction();
      updateMessage(outcome);
      toggleMessage(true);
      await sleep(2);
      toggleMessage(false);
    }
  };

  return (
    <>
      {testAction !== null ? (
        <Button
          color="secondary"
          variant="contained"
          fullWidth
          disabled={disabled}
          onClick={handleClick}
        >
          {text}
        </Button>
      ) : null}
      {displayMessage ? (
        <p
          style={{
            textAlign: 'center',
            marginTop: '15px',
            marginBottom: '15px',
            fontSize: '16px',
            fontWeight: 900,
          }}
        >
          {testMessage}
        </p>
      ) : null}
    </>
  );
};
export default TestButton;
